import { render } from "./self-sort.vue?vue&type=template&id=4d9ad0e0"
import script from "./self-sort.vue?vue&type=script&lang=js"
export * from "./self-sort.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__